import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";

// Custom.
import { SaveConsentDialogProps } from "./global";
import { localStorage, I18n } from "@vocollege/app";

const SaveConsentDialog: React.FC<SaveConsentDialogProps> = (props) => {
  const { context = "Default", redirectUrl = "/" } = props;
  const [agreed, setAgreed] = useState(true);

  const handleAgree = () => {
    localStorage.set(
      `${context}SaveConsent`,
      JSON.stringify({
        value: true,
        created: dayjs().unix(),
      })
    );
    setAgreed(true);
  };

  const handleDisagree = () => {
    window.location.href = redirectUrl;
  };

  // Effects.

  useEffect(() => {
    let agreedSaved = localStorage.get(`${context}SaveConsent`);
    let value = false;
    if (agreedSaved) {
      agreedSaved = JSON.parse(agreedSaved);
      let now = dayjs().unix();
      value = now < (agreedSaved as any)?.created + 3600; // Created plus 1 hours (60 * 60 seconds).
    }
    setAgreed(value);
  }, [context]);

  if (agreed) {
    return <></>;
  }

  return (
    <Dialog open={true} sx={(theme) => ({ zIndex: theme.zIndex.modal + 3 })}>
      <DialogContent>
        <Stack spacing={2}>
          <Typography component="h4" variant="h6">
            {I18n.get.vocertSaveConsent.text01}
          </Typography>
          <Typography component="h6" variant="body1">
            {I18n.get.vocertSaveConsent.text02}
          </Typography>
          <Typography component="p" variant="body2">
            {I18n.get.vocertMisc.inCaseOfQuestions}:{" "}
            <Link href={`mailto:info@vo-college.se`}>info@vo-college.se</Link>
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleDisagree}>
          {I18n.get.vocertActions.disagree}
        </Button>
        <Button variant="contained" color="secondary" onClick={handleAgree}>
          {I18n.get.vocertActions.agree}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveConsentDialog;
